angular.module('Itao.IndicatorMap').directive('barChartDoubleAxis', function (d3, mapConfig) {
  'use strict';

  var accessor = d3.hyperion.accessor;
  var compose = d3.hyperion.compose;
  var germanNumberFormat = d3.hyperion.germanFormat.numberFormat;
  var color = d3.hyperion.indicatorColorAt;
  var sortedAccessor = function(d, i) {
    return i;
  };
  var combineData = function(layer, indicators, selectedDistricts) {
    var selectedUids = selectedDistricts.map(function(district){
      return district.uid;
    });
    var data = [];
    for(var districtUid in layer.districts) {
      if(layer.hasOwnProperty(districtUid)) {
        var valueArray = indicators.map(function(indicator) {
          // '+' for cast to number
          return {value: +layer[districtUid][indicator.uid], key: indicator.key, unit: indicator.unit};
        });
        data.push({key: layer.districts[districtUid].key, name: layer.districts[districtUid].name, values: valueArray, selected: selectedUids.indexOf(districtUid) !== -1});
      }
    }
    return data;
  };

  /**
   * calculate the maximum value
   *
   * @param {array} data the data array
   * @param {boolean} absoluteFlag use absolute values (false for relative values)
   * @returns {float}
   */
  var calculateMaxValue = function(data, absoluteFlag) {
    return d3.max(data.map(function(current){
      return d3.max(current.values.filter(function(value) {
        return (value.unit !== '%') === absoluteFlag;
      }), accessor('value'));
    }));
  };

  /**
   * calculate the minimum value
   *
   * @param {array} data the data array
   * @param {boolean} absoluteFlag use absolute values (false for relative values)
   * @returns {float}
   */
  var calculateMinValue = function(data, absoluteFlag) {
    return d3.min(data.map(function(current){
      return d3.min(current.values.filter(function(value) {
        return (value.unit !== '%') === absoluteFlag;
      }), accessor('value'));
    }));
  };

  /**
   * check if the given valueObject is a relative value
   *
   * @param {Object} value a valueObject
   * @returns {boolean}
   */
  function isRelativeValue(value) {
    return value.unit === '%';
  }

  /**
   * scale a value by one of the given scales depending on the unit
   * @param {Object} value the valueobject
   * @param {Function} absoluteScale the scale for absolute values
   * @param {Function} relativeScale the scale for relative values
   * @returns {Number} the scaled value
   */
  function scaleValueObject(value, absoluteScale, relativeScale) {
    return isRelativeValue(value) ? relativeScale(accessor('value')(value)) : absoluteScale(accessor('value')(value));
  }

  /**
   *
   * @param {Number} value the value to scale
   * @param {String} unit the unit string
   * @param {Function} absoluteScale the scale for absolute values
   * @param {Function} relativeScale the scale for relative values
   * @returns {Number} the scaled value
   */
  function scaleValue(value, unit, absoluteScale, relativeScale) {
    return scaleValueObject({value: value, unit: unit}, absoluteScale, relativeScale);
  }

  var barChartDoubleAxis = function() {
    var indicators = [],
      disabledIndicators = [],
      districtLabelProperty = 'key',
      svgHeight = 200,
      margin = {top: 20, right: 10, bottom: 40, left: 50},
      duration = 400,
      numberFormat = germanNumberFormat(',.2f'),
      tip;

    var chart = function(selection) {
      selection.each(function(data) {
        var filteredIndicators = indicators.filter(function(indicator){
          return disabledIndicators.indexOf(indicator.key) === -1;
        });

        var absoluteIndicators = filteredIndicators.filter(function(indicator){
          return indicator.unit !== '%' && disabledIndicators.indexOf(indicator.key) === -1;
        });

        var relativeIndicators = filteredIndicators.filter(function(indicator){
          return indicator.unit === '%' && disabledIndicators.indexOf(indicator.key) === -1;
        });

        //calculate min and max values
        var minAbsoluteValue = calculateMinValue(data, true);
        var maxAbsoluteValue = calculateMaxValue(data, true);
        var absoluteRatio = maxAbsoluteValue / (maxAbsoluteValue - minAbsoluteValue);

        var minRelativeValue = calculateMinValue(data, false);
        var maxRelativeValue = calculateMaxValue(data, false);
        var relativeRatio = maxRelativeValue / (maxRelativeValue - minRelativeValue);

        var allSameSign = false;
        // check that 0 is included and on the same line for both axis
        if(absoluteIndicators.length > 0 && relativeIndicators.length > 0) {
          // if all numbers are positive set floor to zero
          if (minAbsoluteValue > 0 && minRelativeValue > 0 && minRelativeValue > 0 && maxRelativeValue > 0) {
            allSameSign = true;
            minAbsoluteValue = 0;
            minRelativeValue = 0;
          }

          // if all numbers are negative set ceiling to zero
          if (minAbsoluteValue < 0 && minRelativeValue < 0 && minRelativeValue < 0 && maxRelativeValue < 0) {
            allSameSign = true;
            maxAbsoluteValue = 0;
            maxRelativeValue = 0;
          }

          // align zero line if necessary
          if (!allSameSign && absoluteRatio !== relativeRatio) {
            if (absoluteRatio < relativeRatio) {
              // adjust minRelativeValue
              minRelativeValue = minAbsoluteValue/maxAbsoluteValue*maxRelativeValue;
            } else {
              // adjust minAbsoluteValue
              minAbsoluteValue = minRelativeValue/maxRelativeValue*maxAbsoluteValue;
            }
          }
        } else if(absoluteIndicators.length > 0) {
          // adjustments for only absolute indicators
          if(minAbsoluteValue > 0 ) {
            minAbsoluteValue = 0;
          }
          if(maxAbsoluteValue < 0) {
            maxAbsoluteValue = 0;
          }
          if(minAbsoluteValue === maxAbsoluteValue) {
            minAbsoluteValue -= 1;
            maxAbsoluteValue += 1;
          }
        } else if(relativeIndicators.length > 0) {
          // adjustments for only relative indicators
          if(minRelativeValue > 0 ) {
            minRelativeValue = 0;
          }
          if(maxRelativeValue < 0) {
            maxRelativeValue = 0;
          }
          if(minRelativeValue === maxRelativeValue) {
            minRelativeValue -= 1;
            maxRelativeValue += 1;
          }
        }

        //calculate the space needed for the y-axis labels
        var labelDigitsLeft = Math.max(germanNumberFormat(',')(Math.round(maxAbsoluteValue)).length, germanNumberFormat(',')(Math.round(minAbsoluteValue)).length);
        margin.left = 20 + 10 * labelDigitsLeft;

        var labelDigitsRight = Math.max(germanNumberFormat(',')(Math.round(maxRelativeValue)).length, germanNumberFormat(',')(Math.round(minRelativeValue)).length);
        margin.right = 30 + 10 * labelDigitsRight;

        var districtLabelDigits = d3.max(data.map(function(d) {
          return accessor(districtLabelProperty)(d).length;
        }));
        margin.bottom = 15 + 7 * districtLabelDigits;

        margin.bottom = Math.min(svgHeight / 2, margin.bottom); // use a maximum of half the widget for labels

        var container = d3.select(this).datum([data]).classed('bar-chart', true);

        var svgWidth = selection.node().offsetWidth - 10; // add 10px space for preventing scrollbars

        var width = svgWidth - margin.left - margin.right,
          height = svgHeight - margin.top - margin.bottom;

        if(angular.isDefined(tip)) {
          tip.destroy();
        }

        var colorFromBar = compose(color, function(d, i) {
          return indicators.map(accessor('key')).indexOf(filteredIndicators[i].key);
        });

        tip = d3.tip()
          .attr('class', 'd3-tip')
          .offset(function(){
            return [-5, 0];
          })
          .html(function(d, indicatorNumber, districtNumber){
            var district = data[districtNumber], value;
            if(filteredIndicators[indicatorNumber].unit) {
              value = numberFormat(d.value)+filteredIndicators[indicatorNumber].unit;
            } else {
              value = d.value;
            }
            return '<div class="d3-tip-border" style="border-color:'+colorFromBar(d, indicatorNumber)+';"><b>'+district.name+' ('+district.key+')</b><br><span>'+filteredIndicators[indicatorNumber].name+':</span> <span>'+value+'</span></div>';
          });

        var svg = container.selectAll('svg').data([data]);

        svg.enter()
          .append('svg')
          .attr('preserveAspectRatio', 'xMidYMid meet'); // keep aspectratio on resize, see https://developer.mozilla.org/de/docs/Web/SVG/Attribute/preserveAspectRatio

        svg.attr('viewBox', '0 0 ' + svgWidth + ' ' + svgHeight)
          .attr('height', svgHeight)
          .attr('width', svgWidth); // set viewBox of the svg

        var g = svg.selectAll('g').data([data]);
        var gEnter = g.enter()
          .append('g')
          .attr('class', 'margin-group');

        svg.selectAll('.margin-group').transition().duration(duration).attr('transform', 'translate(' + margin.left + ',' + margin.top + ')'); // apply conventional margins, see http://bl.ocks.org/mbostock/3019563

        // scale for districts
        var x0 = d3.scale.ordinal()
          .rangeRoundBands([0, width], 0.1)
          .domain(data.map(accessor(districtLabelProperty)));

        // scale for each bar per district
        var x1 = d3.scale.ordinal()
          .domain(filteredIndicators.length < 2 ? [0] : d3.range(filteredIndicators.length)) // use only active indicators
          .rangeRoundBands([0, x0.rangeBand()]);

        // scale for bar values
        var yAbsolute = d3.scale.linear()
          .range([height, 0])
          .domain([minAbsoluteValue, maxAbsoluteValue]);

        var yRelative = d3.scale.linear()
          .range([height, 0])
          .domain([minRelativeValue, maxRelativeValue]);

        /**
         * used for initial rendering of bars
         * @param {Object} d valueObject
         * @returns {Number}
         */
        function scaled0Point(d) {
          return scaleValue(0, d.unit, yAbsolute, yRelative);
        }

        var xAxis = d3.svg.axis()
          .scale(x0)
          .orient('bottom');

        var yAxisAbsolute = d3.svg.axis()
          .scale(yAbsolute)
          .orient('left')
          .ticks(Math.min(svgHeight / 40, 10))
          .tickFormat(germanNumberFormat(','));

        var yAxisRelative = d3.svg.axis()
          .scale(yRelative)
          .orient('right')
          .ticks(Math.min(svgHeight / 40, 10))
          .tickFormat(function(d){
            return germanNumberFormat(',')(d) + '%';
          });

        gEnter.append('g')
          .attr('class', 'x axis');

        g.select('.x.axis')
          .attr('transform', 'translate(0,' + height + ')')
          .call(xAxis)
          .selectAll('text')
          .data(data)
          .style('text-anchor', 'end')
          .style('font-weight', function(d) {
            return accessor('selected')(d) ? 'bold' : 'normal';
          })
          .attr('dx', '-.8em')
          .attr('dy', '.15em')
          .attr('transform', 'rotate(-65)');

        gEnter.append('g')
          .attr('class', 'y axis left')
          .append('text')
          .attr('class', 'label-absolute')
          .attr('dy', '-0.5em')
          .style('text-anchor', 'middle')
          .text('Absolute Werte');

        gEnter.append('g')
          .attr('transform', 'translate(' + width + ',0)')
          .attr('class', 'y axis right')
          .append('text')
          .attr('class', 'label-relative')
          .attr('dy', '-0.5em')
          .style('text-anchor', 'middle')
          .text('Relative Werte');

        g.select('.y.axis.left')
          .transition().duration(duration)
          .call(yAxisAbsolute);

        g.select('.y.axis.right')
          .attr('transform', 'translate(' + width + ',0)')
          .transition().duration(duration)
          .call(yAxisRelative);

        // only draw bars if indicators are left
        if(angular.isArray(filteredIndicators) && filteredIndicators.length > 0) {

          // create a feature per district
          var features = g.selectAll('.feature')
            .data(data, accessor('key'));

          features
            .enter().append('g')
            .classed('feature', true)
            .attr('stroke', 'black');

          features
            .attr('transform', function(d){
              return 'translate('+ x0(d[districtLabelProperty])+')';
            })
            .attr('stroke-width', function(d) {
              return accessor('selected')(d) ? '2px' : '0px';
            });

          var bars = features.selectAll('rect')
            .data(accessor('values'), accessor('key'));

          // draw new bars
          bars
            .enter()
            .append('rect')
            .style('fill', colorFromBar)
            .attr('width', 0)
            .attr('x', compose(x1, sortedAccessor))
            .attr('y', scaled0Point)
            .attr('height', 0);

          // update all bars
          bars
            .transition().duration(duration)
            .style('fill', colorFromBar)
            .attr('width', x1.rangeBand())
            .attr('x', compose(x1, sortedAccessor))
            .attr('y', function(d){
              return scaleValue(Math.max(0, accessor('value')(d)), d.unit, yAbsolute, yRelative);
            })
            .attr('height', function(d) {
              return Math.abs(scaleValue(0, d.unit, yAbsolute, yRelative) - scaleValue(accessor('value')(d), d.unit, yAbsolute, yRelative));
            });

          // add tooltips to bars
          bars.call(tip);
          bars.on('mouseover', tip.show)
            .on('mouseout', tip.hide);

          // remove unused bars
          bars.exit().transition().duration(duration)
            .attr('width', 0)
            .remove();
          features.exit().remove();
        } else {
          // remove all bars if no indicators are active
          g.selectAll('rect').remove();
        }
      });
    };

    /**
     * getter/setter for indicators
     * @param {Array} [newIndicators] set of new indicators
     * @returns {*}
     */
    chart.indicators = function(newIndicators) {
      if(!arguments.length) {
        return indicators;
      } else {
        indicators = newIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for disabledIndicators
     * @param {int} [newDisabledIndicators] set of disabled indicators
     * @returns {*}
     */
    chart.disabledIndicators = function(newDisabledIndicators) {
      if(!arguments.length) {
        return disabledIndicators;
      } else {
        disabledIndicators = newDisabledIndicators;
        return chart;
      }
    };

    /**
     * getter/setter for districtLabelProperty
     * @param {string} [newdistrictLabelProperty] name of property to use for districtlabels
     * @returns {*}
     */
    chart.districtLabelProperty = function(newdistrictLabelProperty) {
      if(!arguments.length) {
        return districtLabelProperty;
      } else {
        districtLabelProperty = newdistrictLabelProperty;
        return chart;
      }
    };

    /**
     * getter/setter for svgHeight
     * @param {int} [newHeight] height of the diagram
     * @returns {*}
     */
    chart.height = function(newHeight) {
      if(!arguments.length) {
        return svgHeight;
      } else {
        svgHeight = newHeight;
        return chart;
      }
    };


    /**
     *
     * @returns {*}
     */
    chart.tip = function() {
      return tip;
    };

    return chart;
  };

  /**
   * @param {HTMLElement} element the chart element
   * @returns {number}
   */
  var calculateChartHeight = function(element) {
    return element.closest('.grid-stack-item-content-barChartDoubleAxis').height() - jQuery(element).find('chart-indicator-legend').height() - 10;
  };

  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'barChartDoubleAxis.html',
    scope: {
      layer: '=',
      selectedDistricts: '=',
      indicators: '=',
      dimensionX: '@',
      dimensionY: '@',
      config: '='
    },
    link: function (scope, element) {
      scope.config.disabledIndicators = scope.config.disabledIndicators || [];
      scope.config.districtLabelProperty = scope.config.districtLabelProperty || 'key';
      scope.config.fullscreen = scope.config.fullscreen || false;

      var barChartDoubleAxisFunction = barChartDoubleAxis();

      /**
       * update the chart from one of the watchers
       *
       * @param {*} watcherNewValue new value of the watcher
       * @param {*} watcherOldValue old value of the watcher
       * @param {*} watcherScope new scope from the watcher
       * @param {Number} newHeight the height for the svg
       */
      var rerender = function(watcherNewValue, watcherOldValue, watcherScope, newHeight) {
        if(newHeight == null) {
          newHeight = calculateChartHeight(element);
        }
        var indicators = scope.indicators.filter(function(indicator) {
            return indicator.hasShapeData;
        });

        var filteredIndicators = indicators.filter(function(indicator){
          return scope.config.disabledIndicators.indexOf(indicator.key) === -1;
        });

        var data = combineData(scope.layer, filteredIndicators, scope.selectedDistricts);
        barChartDoubleAxisFunction
          .indicators(indicators)
          .districtLabelProperty(scope.config.districtLabelProperty)
          .disabledIndicators(scope.config.disabledIndicators)
          .height(newHeight);

        d3.select(element.find('.widget-inner:first')[0])
          .data([data])
          .call(barChartDoubleAxisFunction);
      };

      var layerWatcher = scope.$watch('layer', rerender);
      var indicatorWatcher = scope.$watchCollection('indicators', rerender);
      var dimensionWatcher = scope.$watchGroup(['dimensionX', 'dimensionY'], rerender);
      var disabledIndicators = scope.$watchCollection('config.disabledIndicators', rerender);
      var districtLabelPropertyWatcher = scope.$watchCollection('config.districtLabelProperty', rerender);
      var selectedDistrictsWatcher = scope.$watchCollection('selectedDistricts', rerender);

      var legendHeightWatcher = scope.$watch(function() {
        return calculateChartHeight(element);
      }, function(newValue, oldValue){
        if(newValue !== oldValue && newValue > 0) {
          rerender(newValue, oldValue, null, newValue);
        }
      });
      // remove watcher on destroy
      element.on('$destroy', function() {
        layerWatcher();
        indicatorWatcher();
        dimensionWatcher();
        legendHeightWatcher();
        disabledIndicators();
        districtLabelPropertyWatcher();
        selectedDistrictsWatcher();

        // remove tooltip dom element
        if(angular.isDefined(barChartDoubleAxisFunction.tip())) {
          barChartDoubleAxisFunction.tip().destroy();
        }
      });
    }
  };
});
